import { env } from './environment'

const addressFromSpaceId = (spaceId: string | undefined) => {
    return spaceId ? '0x' + spaceId.slice(2, 42) : undefined
}

let BANNED_TOWNS: Set<string> | undefined = undefined

/**
 * Checks if a town is banned
 * @param identifier The town identifier (can be address or spaceId)
 * @returns True if the town is banned, false otherwise
 */
export const isTownBanned = (identifier: string): boolean => {
    if (!env.VITE_BANNED_TOWNS) {
        return false
    }

    if (!BANNED_TOWNS) {
        BANNED_TOWNS = new Set(
            env.VITE_BANNED_TOWNS.split(',').map((addr) => addr.trim().toLowerCase()),
        )
    }

    let townAddress = identifier
    if (identifier && !identifier.startsWith('0x')) {
        const convertedAddress = addressFromSpaceId(identifier)
        if (convertedAddress) {
            townAddress = convertedAddress
        }
    }

    return BANNED_TOWNS.has(townAddress.toLowerCase())
}
